/**
 * Zustand store — selected branchId for admin sidebar branch switcher.
 * null = "All branches" (admin default); manager's branchId is fixed server-side.
 * Persisted in localStorage so selection survives page reload.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BranchFilterState {
  selectedBranchId: string | null;
  setSelectedBranchId: (id: string | null) => void;
}

export const useBranchFilter = create<BranchFilterState>()(
  persist(
    (set) => ({
      selectedBranchId: null,
      setSelectedBranchId: (id) => set({ selectedBranchId: id }),
    }),
    { name: 'clc-branch-filter' },
  ),
);
